var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "url(#paint0_linear_566_3037)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 12.3994C10.3022 12.0228 10.9254 11.7996 11.6008 11.7996H22.4008C23.0761 11.7996 23.6994 12.0228 24.2008 12.3994C24.2007 11.4054 23.3948 10.5996 22.4008 10.5996H11.6008C10.6067 10.5996 9.8009 11.4054 9.80078 12.3994Z",
    fill: "#FFDE30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 14.7994C10.3022 14.4228 10.9254 14.1996 11.6008 14.1996H22.4008C23.0761 14.1996 23.6994 14.4228 24.2008 14.7994C24.2007 13.8054 23.3948 12.9996 22.4008 12.9996H11.6008C10.6067 12.9996 9.8009 13.8054 9.80078 14.7994Z",
    fill: "#FFDE30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6008 15.3996C15.0426 15.3996 15.4008 15.7578 15.4008 16.1996C15.4008 17.0833 16.1171 17.7996 17.0008 17.7996C17.8844 17.7996 18.6008 17.0833 18.6008 16.1996C18.6008 15.7578 18.959 15.3996 19.4008 15.3996H22.4008C23.3949 15.3996 24.2008 16.2055 24.2008 17.1996V21.5996C24.2008 22.5937 23.3949 23.3996 22.4008 23.3996H11.6008C10.6067 23.3996 9.80078 22.5937 9.80078 21.5996V17.1996C9.80078 16.2055 10.6067 15.3996 11.6008 15.3996H14.6008Z",
    fill: "#FFDE30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_566_3037",
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A7EAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.e7a0c2b3f8ff2aec0c4357256ec641b3.svg";
export { ForwardRef as ReactComponent };